module.exports = __webpack_public_path__ + "static/media/illustration-free-trial.f31106be.svg";